import "svg-innerhtml-polyfill";
import "classlist-polyfill";
import "core-js/actual/array/reduce";
import "core-js/actual/array/concat";
import "core-js/actual/object/keys";
import "core-js/actual/object/assign";
import "core-js/actual/array/includes";
import "core-js/actual/array/at";
import "core-js/actual/dom-collections/for-each";

import BikeTheftMap from "./BikeTheftMap.svelte";

import fragments from "../fragments.json";

const components = {
	"bike-theft-map": BikeTheftMap,
	"bike-theft-map-pw": BikeTheftMap,
};

const devContainer = document.querySelector("#dev_container");

fragments.forEach((f) => {
	if (devContainer) {
		if (!f.PREVIEW) return;
		const c = document.createElement("div");
		c.id = "tsil-" + f.name;
		if (f.class) c.classList.add("tslr-block-" + f.class);

		const name = document.createElement("pre");
		name.innerHTML = f.name;
		devContainer.appendChild(name);
		devContainer.appendChild(c);
	}

	const t = document.querySelector("#tsil-" + f.name);
	if (t)
		new components[f.name]({
			target: t,
			hydrate: true,
			intro: true,
			props: {
				name: f.name,
				...(f.props || {}),
			},
		});
});
